import { render, staticRenderFns } from "./ProjectEditorHeader.vue?vue&type=template&id=23637e60"
import script from "./ProjectEditorHeader.vue?vue&type=script&lang=ts"
export * from "./ProjectEditorHeader.vue?vue&type=script&lang=ts"
import style0 from "./ProjectEditorHeader.vue?vue&type=style&index=0&id=23637e60&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports